var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ dragging: _vm.dragging },on:{"mousedown":function($event){$event.stopPropagation();return _vm.start($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }